import React, { useState, useContext, useEffect } from "react";
import Tab from "../tab/tab";
import TopBar from "../../scenes/global/Top-Bar";
import AddedItem from "../added_item/added_item";
import SideBar from "../../scenes/global/Side-Bar";
import Radio from "../radio/radio";
import ViewProp from "../view_prop/view";
import AddMore from "../add_more/add_more";
import BasicSelect from "../select/select";
import Skills from "../../scenes/step/data/skills";
import Skills_sp from "../../scenes/step/data/spSkill";
import Personal from "../../scenes/step/data/personal";
import Sp_personal from "../../scenes/step/data/sp_personal";
import { Box } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import $ from "jquery";
import { useSelector, useDispatch } from "react-redux";
import {
  dispatchSkills,
  dispatchPskills,
  cert_function,
  updateSkills,
  updateSoft_skills,
  generate_my_cv,
  saveSkills
} from "../../Redux/ActionCreator";
import { useNavigate } from "react-router-dom";
//import language context
import { LanguageContext } from "../../scenes/global/languageContext";
import { ToastContainer, toast } from 'react-toastify';

export default function UserSKillsAndLicensing(props) {
  const { language, handleLanguageChange } = useContext(LanguageContext);
  const t_lang = useSelector(lg => lg.t_lang);
  const profile = useSelector(e => e.profile);
  const generated = useSelector(e => e.generateCV);
  const Tech_skills = useSelector(e => e.skills);
  const Personal_skills = useSelector(e => e.p_skills);
  const existing_cv_data = useSelector((prev) => prev.existingCV);
  const secret = useSelector(prev => prev.secret);
  const profile1 = useSelector(e => e.login);
  const userInfo = useSelector(e => e.userInfo);
  let stat = profile1.profile_status.profile_status
  const message = existing_cv_data.message;
  const cv = useSelector(prev => prev.cvId);
  const navigate = useNavigate();
  let sk;
  if (t_lang.selected === "sp") {
    sk = Skills_sp;
  } else if (t_lang.selected === "en") {
    sk = Skills;
  }

  let pk;
  if (t_lang.selected === "sp") {
    pk = Sp_personal;
  } else if (t_lang.selected === "en") {
    pk = Personal;
  }

  let [ s, setS ] = useState(props.skills);
  let [ p, setP ] = useState(props.personal_skill);
  const [selectedValue, setSelectedValue] = useState([]);
  const [skill, setskill] = useState(sk);
  const [chips, setChips] = useState([]);
  const [other, setOther] = useState('none');
  const [currentArray, setCurrentArray] = useState([]);
  const [ cert, setCert ] = useState([]);
  const [ path, setPath ] = useState(false);

  const [selectedOptions, setSelectedOptions] = useState(sk);
  const [selectedOptionsp, setSelectedOptionsp] = useState(pk);
  
  // initialize useSelector and useDispatch hook
  const existing_activities = useSelector(prev => prev.existingCV);
  const dispatch = useDispatch();
  const certMess = useSelector(msg => msg.cert);
  // const technicalSkill = useSelector(sk => sk.skills);
  // const personalSkill = useSelector(pk => pk.p_skills);

  useEffect(() => {
    console.log("location", window.location.pathname)
    if (window.location.pathname === "/user/profile/update/skills" && profile.message !== null) {
      setPath(true);
      let T_skill = [];
      if (Array.isArray(profile.message.Skills) === true) {
        for (let i = 0; i <= profile.message.Skills.length - 1; i++) {
          T_skill.push(profile.message.Skills[i].value);
        }
        setS(T_skill);
      }
      setP([profile.message.Soft_skills.value]);
      console.log("t_skills", T_skill)
    }
    if (Personal_skills.p_skills !== null ) {
      setP(Personal_skills.p_skills);
    }
    if (Tech_skills.skills !== null) {
      setS(Tech_skills.skills);
    }
    if (Tech_skills.skills === null && Personal_skills.p_skills === null && message === null) {
      setS([]);
      setP([]);
    }
  }, []);

  useEffect(() => {

    if (certMess.cert !== null) {
      setChips(certMess.cert);
      setCert(certMess.cert);
    }

    if (t_lang.selected === "sp") {
      setSelectedOptions(Skills_sp)/* 
      sk = Skills_sp; */
    } else if (t_lang.selected === "en") {
      setSelectedOptions(Skills);/* 
      sk = Skills; */
    }

    if (t_lang.selected === "sp") {
      setSelectedOptionsp(Sp_personal);/* 
      pk = Sp_personal; */
    } else if (t_lang.selected === "en") {
      setSelectedOptionsp(Personal);/* 
      pk = Personal; */
    }
    
  }, [t_lang.selected, Personal, Sp_personal, Skills, Skills_sp ]);

      const handlesets = (event, value) => {
        if (window.location.pathname === "/user/profile/update/skills" && profile.message !== null) {
          // update skills here
          dispatch(updateSkills(value));
        } else {
          setS(value);
          dispatch(dispatchSkills(value));
        }
      };
      
      const handlesetp = (event, value) => {
        if (window.location.pathname === "/user/profile/update/skills" && profile.message !== null) {
          // update soft dkills here
          dispatch(updateSoft_skills(value));
        } else {
          setP(value);
          dispatch(dispatchPskills(value));
        }
      };

/*       useEffect(() => {
        if (existing_activities.message !== null) {
          setP(existing_activities.message.Personal_skills);
          setS(existing_activities.message.Technical_skills)
        }
      }, []) */

      console.log("Tech skill", s)
      const handleInputChange = (event, value) => {
            if (!value.includes(',')) {
                return false;
              }
            const newOptions = value
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item !== '')
            .filter((item) => !selectedOptions.includes(item));
            console.log("new option", newOptions)
            if (newOptions.length === 0) {
              return false;
            }
           
            const newArray = [...newOptions, ...selectedOptions];
            setSelectedOptions(newArray);
      };

        const handleInputChangep = (event, value) => {
                if (!value.includes(',')) {
                    return false;
                }
                const newOptions = value
                .split(',')
                .map((item) => item.trim())
                .filter((item) => item !== '')
                .filter((item) => !selectedOptionsp.includes(item));
                console.log(newOptions)
                if (newOptions.length === 0) {
                    return false;
                }
                const newArray = [...newOptions, ...selectedOptionsp];
                setSelectedOptionsp(newArray);
        };

    let instruction;
    if (window.outerWidth <= 450) {
      instruction = `${language["select_skill_sm"]};`
    } else {
      instruction = `${language["select_skill"]}`
    }




    const handleAdd = () => {
      if ( $('[name="cert"]').val() === "") {
        setTimeout(() => {
          toast.error("Add certificate", {
              position: toast.POSITION.TOP_RIGHT,
          });
      }, 50);
      } else {
        const newCert = cert;
        let k = cert.length;
        const data = {
          key: k,
          cert: $('[name="cert"]').val()
        }
        newCert.push(data);
        setCert(newCert);
        setChips(newCert);
        dispatch(cert_function(newCert));
      }
    }

    const handleClickOperation = (desiredKey) => {
      let certificate = cert;
      let desiredObject = certificate.find((item) => item.key === desiredKey.key);
      let w = certificate.filter(chip => chip.key !== desiredObject.key);
      
      $('[name="cert"]').val(desiredObject.cert);
      // $('[name="work_place"]').val(desiredObject.Where_i_worked_location);

      console.log("desired object", desiredObject);
      w.forEach((element) => {
          element.key = w.indexOf(element);
          console.log("work key", w.indexOf(element));
      });
      setCert(w);
        setChips(w);
        dispatch(cert_function(w));
        desiredObject = [];
  
        console.log("inner chips", chips);
        console.log("inner work", w);
    }
  
    // handleClick function
    const handleClick = (desiredKey) => {
      const cert = $('[name="cert"]').val();
      if (cert !== "") {
          handleAdd(); // add already mapped values back to the work array if the client/user forget to click add, this is so, so as to save users experience.
          handleClickOperation(desiredKey);
      } else {
          handleClickOperation(desiredKey);
      }
    }

    const handleDelete = (chipToDelete) => {
      const newCert = cert.filter(element => {
          if (element.key !== chipToDelete.key)
              return element;
      })
      console.log("new cert", newCert);
      newCert.forEach((element) => {
          element.key = newCert.indexOf(element);
      })
      setCert(newCert);/* 
      setwork((chips) => work.filter((chip) => chip.key !== chipToDelete.key )); */
      setChips(newCert);
      dispatch(cert_function(newCert));
      console.log("chips", chips);
       console.log("delete cert", cert);
    }

    const handleNextStep = () => {
      if (window.location.pathname === "/user/profile/update/skills") {
        navigate(`/user/profile/:${userInfo.user.profile_id}`)
      } else if (window.location.pathname === `/form/${cv.id}/update`) {
        let newV = generated.message;
        let t = s;
        let pS = p;
        newV.Technical_skills = s;
        newV.Personal_skills = p;
        dispatch(generate_my_cv(newV));
        navigate("/allCv");
      } else {
        if (stat === "false" || stat === false) {
          dispatch(saveSkills(s, p, secret.secret));
        }
        // dispatch(saveSkills(s, p, secret.secret));
        props.handleStepChange();
      }
    }

  return (
    <div className="grid grid-cols-auto md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash">
      <TopBar topBarShowMenu={true} />
      <SideBar />
      <div className="px-3 lg:pl-6 my-8 w-full">
        <div className="w-full max-w-[793px] h-[54px] bg-white bg-opacity-50 rounded-[40px] shadow border border-indigo-400 border-opacity-30 flex flex-col justify-center">
          <p className="text-stone-950 text-base md:text-[28px] font-semibold ml-12 max-[300px]:ml-6">
            {language["resume_caph1"]}
          </p>
        </div>
        <p className="w-full max-w-[741px] mt-2 px-3 lg:pl-6">
          <span className="text-black text-opacity-50 text-[14px] md:text-base font-normal">
            {language["Hey_there"]}
          </span>
        </p>
        <div className="max-w-[800px] w-full mt-8 p-8 bg-white bg-opacity-80 rounded-2xl shadow border border-indigo-400 border-opacity-30 flex-col justify-start items-start gap-16 inline-flex">
          <div className="tabarea justify-start items-center gap-6 inline-flex w-full flex-shrink-0 w-full max-w-[calc(100vw-88px)] overflow-hidden">
            <Tab
              num="1"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="2"
              current={false}
              completed={true}
              className="max-[330px]:hidden"
            />
            <Tab
              num="3"
              current={false}
              completed={true}
              className="max-[300px]:hidden"
            />
            <Tab
              // label="Skills & Licensing"
              label={`${language["skills_licencing"]}`}
              current={true}
              completed={false}
            />
            <Tab num="5" current={false} completed={false} />
            <Tab num="6" current={false} completed={false} />
            <Tab num="7" current={false} completed={false} />
            <Tab num="8" current={false} completed={false} />
            <Tab num="9" current={false} completed={false} />
          </div>
          <div className='sm:mt-2 mb-4 py-2 px-4 sm:mb-2 sm:py-0' >
            <h6 className='top-2 text-[24px] text-pry-920 sm:text-sm'>
              {instruction}
            </h6>
          </div>
          <div className="flex-col justify-start items-start gap-12 flex w-full">
            <div className="flex-col justify-start items-start gap-12 flex w-full">
              <div className="flex-col justify-start items-start gap-3 flex w-full">
                <div className="flex gap-3 items-center">
                  <div className="w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="technicalSkill"
                  >
                    {language["sk_tech"]}
                  </label>
                </div>
                <Box className="w-full mb-4 ">
                  <Autocomplete
                    multiple
                    value={s}
                    onChange={handlesets}
                    id="multiple-limit-tags"
                    options={selectedOptions}
                    onInputChange={handleInputChange}
                    freeSolo
                    filterOptions={(options, state) => options}
                    name="technical_skills"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={`${language["int_p"]}`}
                      />
                    )}
                  />
                </Box>
                {/* <div className="flex-col justify-start items-start gap-3 flex w-full">
                <p className="text-black text-base font-medium">
                  You have added
                </p>
                <div className="flex flex-wrap gap-3">
                  <AddedItem item="Plumbing" />
                  <AddedItem item="Dry Cleaning" />
                  <AddedItem item="Dry Cleaning" />
                  <AddedItem item="Plumbing" />
                </div>
                <ViewProp length={4} />
                <AddMore text="skills" />
              </div> */}
              </div>
              <div className="flex-col justify-start items-start gap-12 flex w-full">
                <div className="flex-col justify-start items-start gap-3 flex w-full">
                  <div className="flex gap-3 items-center">
                    <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                    <label
                      className="text-black text-base font-medium"
                      for="softSkill"
                    >
                      {language["soft_proud"]}
                    </label>
                  </div>
                  <Box className="w-full">
                    <Autocomplete
                      multiple
                      freeSolo
                      value={p}
                      id="multiple-limit-tags"
                      filterOptions={(options, state) => options}
                      options={selectedOptionsp}
                      onInputChange={handleInputChangep}
                      onChange={handlesetp}
                      renderInput={(params) => (
                        <TextField
                          name="personal_skills"
                          {...params}
                          placeholder={`${language["int_p"]}`}
                        />
                      )}
                    />
                  </Box>
                </div>
                {/* <div className="flex-col justify-start items-start gap-3 flex w-full">
                <p className="text-black text-base font-medium">
                  You have added
                </p>
                <div className="flex flex-wrap gap-3">
                  <AddedItem item="Communication" />
                  <AddedItem item="Presentation" />
                  <AddedItem item="Team Management" />
                  <AddedItem item="Communication" />
                  <AddedItem item="Presentation" />
                  <AddedItem item="Team Management" />
                </div>
                <ViewProp length={6} />
                <AddMore text="skills" />
              </div> */}
            </div>
            <div className="flex-col justify-start items-start gap-12 flex w-full">
              <div className="flex-col justify-start items-start gap-3 flex w-full">
                <div className="flex gap-3 items-center">
                  <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="certificateBool"
                  >{language["certification_licence"]}
                  </label>
                </div>
                {/* <div className="flex gap-3">
                  <Radio name="hasAward" label="No" id="certificateBool" />
                  <Radio name="hasAward" label="Yes" id="certificateBool" />
                </div> */}
                <input
                  type="text"
                  className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                  placeholder={`${language["licence_place"]}`}
                  id="certificateName" name="cert"
                />
                {/* <p className="text-zinc-400 text-base font-medium">
                    {language["where_when_get"]}</p> */}
              </div>
              <div className="flex-col justify-start items-start gap-3 flex w-full">
                <AddMore text="certifications" onClick={handleAdd} />
                <p className="text-black text-base font-medium">
                    {language["have_added"]}
                </p>
                <div className="flex flex-wrap gap-3">
                  {chips?.map((cert, key) => (
                  <AddedItem item={cert.cert} key={key} onClick={() => handleClick(cert)} delete={() => handleDelete(cert)} />
                  ))}
                </div>
                {/* <ViewProp length={4} /> */}
              </div>
            </div>
          </div>
          <div className="self-stretch flex-col sm:flex-row justify-between items-start gap-4 inline-flex">
            {path === true ? null :
              <button className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]" onClick={props.handleStepChangeBack}>
                <span className="text-center text-orange-500 text-base font-semibold">
                  {language["previous_btn"]}
                </span>
              </button>
          }
            <button className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]" onClick={handleNextStep}>
              <span className="text-center text-white text-base font-semibold">
                  {language["save_n_continue"]}
              </span>
            </button>
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
    </div>
  );
}